// extracted by mini-css-extract-plugin
export default {"form-check-input":"Checkbox_form-check-input__Q5Ywf","black-checkbox":"Checkbox_black-checkbox__GuKAj"};